// extracted by mini-css-extract-plugin
export default {"circle":"avatar_circle__M7Tnn","name":"avatar_name__HpLq+"};